import styled from "styled-components";

export const ItemForm = styled.div`
  margin: 4px auto;
  text-align: center;
  justify-content: center;
  max-width: 50%;
`;